var $ = require('jquery');
require('jquery.cookie');

var self = {};

self.initialise = function () {
  $(document).ready(function () {
    var $cookiePanel = $('.js-country-snack-panel'),
      $cookieClose = $('.js-country-snack-close', $cookiePanel);

    const ACTIVE = 'is-active';

    // Cookie bar - yummy
    $cookieClose.click(function (e) {
      e.preventDefault();
      $.cookie('country-snack', true, { path: '/' });
      $cookiePanel.removeClass(ACTIVE);
    });

    var cookie = $.cookie('country-snack');
    if (cookie === undefined) {
      $cookiePanel.addClass(ACTIVE);
    }
  });
};

module.exports = self;



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/rebuild-components/init-country-snack.js